var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.955078,
    y: 0.56488,
    width: 40.3361,
    height: 40.3361,
    rx: 6.05042,
    fill: "#106F60"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_116_13844",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 8,
    width: 25,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.02148,
    y: 8.6322,
    width: 24.2017,
    height: 24.2017,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_116_13844)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1141 26.7835C19.8284 26.7835 19.5891 26.6866 19.3961 26.493C19.2025 26.3001 19.1057 26.0608 19.1057 25.7751C19.1057 25.4893 19.2025 25.25 19.3961 25.0571C19.5891 24.8635 19.8284 24.7667 20.1141 24.7667H22.1309C22.4166 24.7667 22.6563 24.8635 22.8499 25.0571C23.0428 25.25 23.1393 25.4893 23.1393 25.7751C23.1393 26.0608 23.0428 26.3001 22.8499 26.493C22.6563 26.6866 22.4166 26.7835 22.1309 26.7835H20.1141ZM13.0553 16.6994C12.7696 16.6994 12.5302 16.603 12.3373 16.41C12.1437 16.2164 12.0469 15.9767 12.0469 15.691C12.0469 15.4053 12.1437 15.1656 12.3373 14.972C12.5302 14.7791 12.7696 14.6826 13.0553 14.6826H29.1897C29.4754 14.6826 29.7148 14.7791 29.9077 14.972C30.1013 15.1656 30.1981 15.4053 30.1981 15.691C30.1981 15.9767 30.1013 16.2164 29.9077 16.41C29.7148 16.603 29.4754 16.6994 29.1897 16.6994H13.0553ZM16.0805 21.7414C15.7948 21.7414 15.5551 21.6446 15.3615 21.451C15.1686 21.2581 15.0721 21.0188 15.0721 20.733C15.0721 20.4473 15.1686 20.2077 15.3615 20.014C15.5551 19.8211 15.7948 19.7246 16.0805 19.7246H26.1645C26.4502 19.7246 26.6896 19.8211 26.8825 20.014C27.0761 20.2077 27.1729 20.4473 27.1729 20.733C27.1729 21.0188 27.0761 21.2581 26.8825 21.451C26.6896 21.6446 26.4502 21.7414 26.1645 21.7414H16.0805Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.7c17eb09d61793e578ab1889f35084b3.svg";
export { ForwardRef as ReactComponent };